import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import {
  ResponseStatusCodeFunction,
  lmsTransportWithLogoutHandler,
} from './transports';
import { LmsAssessmentTeacherReportsAPIServiceV1 } from '@protos/learning_management/lms.assessment.teacher.apis_connect';

// export const LmsAssessmentStudentAPIServiceV1Client = createPromiseClient(
//   LmsAssessmentStudentReportsAPIServiceV1,
//   lmsTransport
// );

export const useLmsAssessmentTeacherReportsAPIServiceV1ClientWithStatusCodeHandler =
  (
    options: Partial<ConnectTransportOptions>,
    responseStatusCodeFunction: ResponseStatusCodeFunction
  ) =>
    createPromiseClient(
      LmsAssessmentTeacherReportsAPIServiceV1,
      lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
    );
